module.exports = __webpack_public_path__ + "img/002.cf0ebe48.png";